import { ReactNode } from "react";
import { View } from "./View";

export interface ISectionedHeaderProps {
  mainHead: ReactNode;
  subHead: ReactNode;
  hasBorder: boolean;
  className?: string;
}

export const SectionedHeader = (props: ISectionedHeaderProps) => {
  return <View {...props} />;
};
